import { render } from "./Archived.vue?vue&type=template&id=049349fa&scoped=true&lang=pug"
import script from "./Archived.vue?vue&type=script&lang=js"
export * from "./Archived.vue?vue&type=script&lang=js"

import "./Archived.vue?vue&type=style&index=0&id=049349fa&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049349fa"]])

export default __exports__